export const DECISION_CHIP_MAP = {
  accepted_as_sufficient: { label: 'Reviewer accepted', color: 'success' },
  needs_targeted_test: { label: 'Needs targeted test', color: 'error' },
  needs_product_knowledge_refinement: { label: 'Needs PK refinement', color: 'warning' },
  not_applicable: { label: 'Not applicable', color: 'default' },
  deferred: { label: 'Deferred', color: 'info' },
};

